<template>
  <header class="header" id="header">
    <div class="header__container container">
      <button id="burger" class="header__burger btn-reset">
        <svg :style="[{ fill: mainPage ? '#fff' : '#000' }]">
          <use xlink:href="#burger-icon"></use>
        </svg>
      </button>
      <div :style="[{ display: mainPage || $route.name === 'user' ? 'flex' : 'none' }]" class="header__logo-wrapper">
        <router-link class="header__logo-link" :to="{name: 'main'}">
          <img
            class="header__logo logo"
            src="@/assets/img/logo.png"
            alt="SymbioWay"
          />
        </router-link>
        <span class="header__span" :class="{ 'inactive': $route.name === 'user' }">
          реферальная программа
        </span>
      </div>
      <HeaderNav :main-page="mainPage" />
    </div>
  </header>
</template>

<style scoped>
.header {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  padding: 26px 0;
  z-index: 10;
}

.header__container {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
}

.header__burger {
  display: none;
  width: 40px;
  height: 40px;
}

.header__burger svg {
  width: 100%;
  height: 100%;
  fill: var(--white);
}

.header__logo-wrapper {
  display: flex;
  align-items: center;
}

.header__logo {
  margin-right: 7px;
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.header__logo-link {
  display: block;
  margin-right: 7px;
  width: 64px;
  height: 58px;
}

.header__span {
  display: block;
  max-width: 185px;
  font-size: 14px;
  line-height: 200%;
  font-weight: 500;
  text-transform: uppercase;
  color: var(--white);
}

.header__span.inactive {
  display: none;
}

@media (max-width: 769px) {
  .header {
    padding: 10px 0;
  }

  .header__container {
    align-items: center;
  }

  .header__logo-wrapper {
    margin-right: 0;
    margin-left: auto;
    order: 2;
  }

  .header__logo-link {
    margin-right: 0;
    height: 40px;
  }

  .header__span {
    display: none;
  }

  .header__burger {
    display: block;
  }
}
</style>

<script>
import HeaderNav from '@/components/HeaderNav.vue'
export default {
  components: { HeaderNav },
  data () {
    return {
      mainPage: false
    }
  },
  watch: {
    '$route.params': {
      handler () {
        if (this.$route.name === 'main') this.mainPage = true
        else this.mainPage = false
      },
      immediate: true
    }
  }
}
</script>
